import { render, staticRenderFns } from "./caluseFormItem.vue?vue&type=template&id=7132a276&"
import script from "./caluseFormItem.vue?vue&type=script&lang=ts&"
export * from "./caluseFormItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports